<template>
  <section>
    <div v-if="loading">
      <!-- Edit -->
      <div class="intro-y box mt-6" v-if="boxedit">
        <div
          class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
        >
          <h2 class="font-medium text-base mr-auto">Editar Usuario</h2>
        </div>
        <form @submit.prevent="updateUser">
          <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
            <div class="col-span-6 sm:col-span-6">
              <label>Nombre:</label>
              <input
                v-on:input="updateValue('name', $event)"
                type="text"
                class="input w-full border mt-2 flex-1"
                :value="user.name"
                required
              />
            </div>
            <div class="col-span-6 sm:col-span-6">
              <label>Correo:</label>
              <input
                v-on:input="updateValue('email', $event)"
                type="email"
                class="input w-full border mt-2 flex-1"
                :value="user.email"
                required
              />
            </div>
            <div class="col-span-2 sm:col-span-2">
              <label>Estado</label>
              <select
                class="input w-full border mt-2"
                v-on:input="updateValue('active', $event)"
                :value="user.active"
                required
              >
                <option disabled>Seleccione el usuario</option>
                <option value="0">Inactivo</option>
                <option value="1">Activo</option>
              </select>
            </div>
            <div class="col-span-4 sm:col-span-4">
              <label>Contraseña (opcional):</label>
              <input
                v-on:input="updateValue('password', $event)"
                type="text"
                class="input w-full border mt-2 flex-1"
                :value="user.password"
              />
            </div>
            <div class="col-span-3 sm:col-span-3">
              <label>Perfil</label>
              <select
                class="input w-full border mt-2"
                v-on:input="updateValue('profile_id', $event)"
                :value="user.profile_id"
                required
              >
                <option disabled>Seleccione el equipo</option>
                <option v-for="profile in filteredProfiles" :key="profile.id">
                  {{ profile.name }}
                </option>
              </select>
            </div>
            <div class="col-span-3 sm:col-span-3">
              <label>Role</label>
              <select
                class="input w-full border mt-2"
                v-on:input="updateValue('role', $event)"
                :value="user.roles[0].id"
                required
              >
                <option disabled>Seleccione el role</option>
                <option value="3">Lider</option>
                <option value="4">Trabajador</option>
              </select>
            </div>
          </div>
          <div class="px-5 py-3 text-right border-t border-gray-200">
            <button
              type="button"
              v-on:click="closeEditUser()"
              class="button w-20 border text-gray-700 mr-1"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="button w-20 bg-theme-1 text-white"
              id="update"
            >
              Modificar
            </button>
          </div>
        </form>
      </div>
      <!-- END: Edit -->

      <!-- Filter -->
      <h2 class="intro-y text-lg font-medium mr-auto mt-8">Mi Equipo</h2>
      <div class="intro-y flex flex-col-reverse sm:flex-row items-center">
        <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"></div>
        <div class="w-full sm:w-auto flex">
          <a
            data-target="#user"
            data-toggle="modal"
            class="button text-white bg-theme-1 shadow-md mr-2"
            >Crear Usuario</a
          >
        </div>
      </div>
      <!-- END: Filter -->

      <!-- List -->
      <div class="grid grid-cols-12 gap-6 mt-5">
        <div
          class="intro-y col-span-12 md:col-span-6"
          v-for="user in filteredUsers"
          :key="user.id"
        >
          <div class="box">
            <div
              class="flex flex-col lg:flex-row items-center p-5 border-b border-gray-200"
            >
              <div class="w-24 h-24 lg:w-12 lg:h-12 image-fit lg:mr-1">
                <img
                  alt="Profile"
                  class="rounded-full"
                  :src="user.avatar"
                  v-if="user.avatar"
                />
                <img
                  alt="Profile"
                  class="rounded-full"
                  src="/static/images/profile.png"
                  v-else
                />
              </div>
              <div
                class="lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0"
              >
                <a href="#" class="font-medium"
                  >{{ user.name }} ({{ user.roles[0].name }})</a
                >
                <div class="text-gray-600 text-xs">{{ user.email }}</div>
                <div class="text-gray-600 text-xs">
                  {{ user.team ? user.team.name : '-' }} :
                  {{ user.profile ? user.profile.name : '-' }}
                </div>
                <div class="text-gray-600 text-xs">
                  {{ user.accounts.length }} Cuentas Asociadas
                </div>
              </div>
              <div class="flex -ml-2 lg:ml-0 lg:justify-end mt-3 lg:mt-0">
                <a
                  v-if="user.active === 0"
                  v-on:click="editUser(user)"
                  class="pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in"
                  title="Estado"
                >
                  <app-icon
                    v-bind:name="'alert-triangle'"
                    v-bind:classname="'w-4 h-4 mr-2'"
                  ></app-icon>
                </a>
                <router-link
                  :to="'/admin/calendar/' + user.slug"
                  class="pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in"
                >
                  <app-icon
                    v-bind:name="'calendar'"
                    v-bind:classname="'w-4 h-4 mr-2'"
                  ></app-icon>
                </router-link>
                <a
                  v-on:click="editUser(user)"
                  class="pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in"
                >
                  <app-icon
                    v-bind:name="'edit'"
                    v-bind:classname="'w-4 h-4 mr-2'"
                  ></app-icon>
                </a>
                <a
                  v-on:click="removeUser(user)"
                  class="pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in"
                >
                  <app-icon
                    v-bind:name="'trash'"
                    v-bind:classname="'w-4 h-4 mr-2'"
                  ></app-icon>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END: List -->

      <!-- Modal -->
      <div class="modal" id="user">
        <div class="modal__content modal__content--md">
          <div
            class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
          >
            <h2 class="font-medium text-base mr-auto">Crear Usuario</h2>
          </div>
          <form @submit.prevent="createUser">
            <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
              <div class="col-span-6 sm:col-span-6">
                <label>Nombre:</label>
                <input
                  type="text"
                  class="input w-full border mt-2 flex-1"
                  v-model="user.name"
                  required
                />
              </div>
              <div class="col-span-6 sm:col-span-6">
                <label>Contraseña:</label>
                <input
                  type="password"
                  class="input w-full border mt-2 flex-1"
                  v-model="user.password"
                  required
                />
              </div>
              <div class="col-span-12 sm:col-span-12">
                <label>Correo:</label>
                <input
                  type="email"
                  class="input w-full border mt-2 flex-1"
                  v-model="user.email"
                  required
                />
              </div>
              <div class="col-span-6 sm:col-span-6">
                <label>Perfil</label>
                <select
                  class="input w-full border mt-2 flex-1"
                  v-model="user.profile_id"
                  required
                >
                  <option disabled>Seleccione el perfil</option>
                  <option
                    v-for="profile in filteredProfiles"
                    v-bind:value="profile.id"
                    :key="profile.id"
                  >
                    {{ profile.name }}
                  </option>
                </select>
              </div>
              <div class="col-span-6 sm:col-span-6">
                <label>Role</label>
                <select
                  class="input w-full border mt-2 flex-1"
                  v-model="user.role"
                  required
                >
                  <option disabled>Seleccione el role</option>
                  <option value="leader">Lider</option>
                  <option value="employee">Trabajador</option>
                </select>
              </div>
            </div>
            <div class="px-5 py-3 text-right border-t border-gray-200">
              <button
                type="button"
                data-dismiss="modal"
                class="button w-20 border text-gray-700 mr-1"
              >
                Cancelar
              </button>
              <button
                type="submit"
                class="button w-20 bg-theme-1 text-white"
                id="create"
              >
                Crear
              </button>
            </div>
          </form>
        </div>
      </div>
      <!-- Modal End -->
    </div>

    <div v-else>
      <app-loading></app-loading>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Icon from '@/components/admin/partials/Icon'
import Loading from '@/components/admin/partials/LoadingWhite'

export default {
  name: 'AdminTeam',
  data() {
    return {
      loading: false,
      boxedit: false,
      user: {
        name: '',
        email: '',
        password: '',
        team_id: '',
        profile_id: '',
        role: '',
        entity: 'user',
      },
      user_current: {},
    }
  },
  computed: {
    ...mapGetters({
      auth: 'getUser',
      users: 'getUsers',
      profiles: 'getProfiles',
      usersession: 'getUser',
    }),
    filteredUsers() {
      var emails = [
        'diana.florez@inxaitcorp.com',
        'juan.garcia@inxaitcorp.com',
        'aprendiz.th@inxaitcorp.com',
        'lady.ortega@inxaitcorp.com',
        //'juan.ruiz@inxaitcorp.com',
      ]
      //console.log(this.auth)
      if (emails.includes(this.auth.email)) {
        return this.users.filter((item) => {
          if (item.deleted_at === null) {
            return item
          }
        })
      } else {
        return this.users.filter((item) => {
          if (item.team_id === this.usersession.team_id) {
            return item
          }
        })
      }
    },
    filteredProfiles() {
      return this.profiles.filter((item) => {
        if (item.team_id === this.usersession.team_id) {
          return item
        }
      })
    },
  },
  beforeMount() {
    //SEND ENTITY AND MUTATION
    this.getAll('user').then(() => {
      this.loading = true
    })
    this.getList('profile').then(() => {
      this.loading = true
    })
  },
  methods: {
    createUser() {
      var vm = this
      window.$('#create').button('loading')
      vm.user.team_id = vm.usersession.team_id
      vm.store(vm.user)
        .then((item) => {
          window.$('#user').modal('hide')
          vm.user = {
            name: '',
            email: '',
            password: '',
            team_id: '',
            profile_id: '',
            role: '',
            entity: 'user',
          }
          vm.$router.replace(vm.$route.query.redirect || '/admin/team')
        })
        .catch((error) => {
          window.$('#create').button('reset')
          this.user = {
            name: '',
            email: '',
            password: '',
            team_id: '',
            profile_id: '',
            role: '',
            entity: 'user',
          }
        })
    },
    removeUser: function (value) {
      var vm = this
      vm.form = {
        id: value.id,
        entity: 'user',
      }
      vm.remove(vm.form, 'user')
        .then((user) => {
          vm.loading = true
          vm.$router.replace(vm.$route.query.redirect || '/admin/team')
        })
        .catch((message) => {
          vm.loading = true
        })
    },
    editUser: function (value) {
      this.boxedit = true
      this.user = value
    },
    closeEditUser: function () {
      this.boxedit = false
      this.profile_current = {}
    },
    updateUser: function (value) {
      var vm = this
      vm.form = {
        id: vm.user.id,
        entity: 'user',
        name: vm.user_current.name,
        email: vm.user_current.email,
        password_edit: vm.user_current.password,
        active: vm.user_current.active,
        profile_id: vm.user_current.profile_id,
        role: vm.user_current.role,
      }
      window.$('#update').button('loading')
      vm.loading = false
      vm.update(vm.form)
        .then((item) => {
          vm.loading = true
          vm.boxedit = false
          vm.user = { name: '', entity: 'user' }
          window.$('#update').button('reset')
          vm.$router.replace(vm.$route.query.redirect || '/admin/team')
        })
        .catch((message) => {
          vm.loading = true
        })
    },
    updateValue(attribute, e) {
      this.user_current[attribute] = e.target.value
    },
    ...mapActions(['getAll', 'getList', 'store', 'update', 'remove']),
  },
  components: {
    appIcon: Icon,
    appLoading: Loading,
  },
}
</script>



// WEBPACK FOOTER //
// Team.vue?2087561e